/* eslint-disable */
// package: cardreader
// file: cardreader.proto

var cardreader_pb = require("./cardreader_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var CardReader = (function () {
  function CardReader() {}
  CardReader.serviceName = "cardreader.CardReader";
  return CardReader;
}());

CardReader.RequestCards = {
  methodName: "RequestCards",
  service: CardReader,
  requestStream: false,
  responseStream: false,
  requestType: cardreader_pb.CRCardsRequest,
  responseType: cardreader_pb.CRCardsReply
};

CardReader.CardsStatus = {
  methodName: "CardsStatus",
  service: CardReader,
  requestStream: false,
  responseStream: true,
  requestType: cardreader_pb.CRCardsRequest,
  responseType: cardreader_pb.CRCardsReply
};

exports.CardReader = CardReader;

function CardReaderClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

CardReaderClient.prototype.requestCards = function requestCards(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(CardReader.RequestCards, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

CardReaderClient.prototype.cardsStatus = function cardsStatus(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(CardReader.CardsStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

exports.CardReaderClient = CardReaderClient;

